// Backport from AngularJS (webroot/_ui/desktop/common/js/angular/controllers/loginPageController.js)

const loginPage = {
    $body: undefined,
    init() {
        if ($('#login-page').length) {
            this.$body = $('body');
            this.bindEvents();
            this.showLoginForm();
        }
    },
    showLoginForm() {
        let showScreenParams   = {
            screenSet:         'ATA-RegistrationLogin',
            containerID:       'cdc-loginPageLogin',
            startScreen:       'gigya-login-screen',
            onAfterScreenLoad: loginPage.onAfterScreenLoadEvent
        };
        window.gigya.accounts.showScreenSet(showScreenParams);
    },
    onAfterScreenLoadEvent(evt) {
        loginPage.insertForgotPwdLink();
        if (evt.currentScreen === 'gigya-complete-registration-screen') {

            let $regCompletitionForm   = $('#gigya-complete-registration-screen'),
                $consentCheckbox       = $regCompletitionForm.find('input[name*="privacy.alphatauri"]'),
                $mandatoryConsentLabel = $regCompletitionForm.find('.consent-mandatory');

            $('.gigya-input-submit').one('click', function () {
                if (!$consentCheckbox.prop('checked')) {
                    $mandatoryConsentLabel.css({visibility: 'visible'})
                }
            });

            $consentCheckbox.on('change', function () {
                !$consentCheckbox.prop('checked') ? $mandatoryConsentLabel.css({visibility: 'visible'}) : $mandatoryConsentLabel.css(
                        {visibility: 'hidden'})
            });

        }
    },
    insertForgotPwdLink() {
        const forgotPwdLink       = document.getElementById('forgotPwdLink');
        const cdcLoginPageContent = document.getElementById('cdc-loginPageLogin_content');
        if (forgotPwdLink !== null) {
            cdcLoginPageContent.append(forgotPwdLink);
            forgotPwdLink.removeAttribute('hidden');
        }
    },
    handleRegisterButton(event) {
        // hide register button
        event.target.setAttribute('hidden', '');

        // replace content with CDC register form
        $('#login-page__login-view').remove();

        // show login form
        var showScreenParams = {
            screenSet:   'ATA-RegistrationLogin',
            containerID: 'checkoutLoginScreenContainer',
            startScreen: 'gigya-login-screen'
        };

        gigya.accounts.showScreenSet(showScreenParams);

        var hideLoginScreenParams = {
            screenSet:   'ATA-RegistrationLogin',
            containerID: 'cdc-loginPageLogin'
        };

        gigya.accounts.hideScreenSet(hideLoginScreenParams);

        var showRegisterScreenParams = {
            screenSet:   'ATA-RegistrationLogin',
            containerID: 'cdc-register-view',
            startScreen: 'gigya-register-screen'
        };

        $('#js-login-page__register-view').show();
        gigya.accounts.showScreenSet(showRegisterScreenParams);
    },
    bindEvents() {
        this.$body.on('click', '.login-page__register-button', (evt) => {
            this.handleRegisterButton(evt);
        });

        // For checkout login on mobile - "No account?" action
        this.$body.on('click', '.login-page--no-account', (evt) => {
            evt.preventDefault();
            $('#registerAccount')[0].scrollIntoView({behavior: "smooth"})
        });
    }
};

export default loginPage;
